import type mapboxgl from 'mapbox-gl';

/** Apply once on a ready frame, even while paint animations prevent idle. */
export function whenMapStyleReady(map: mapboxgl.Map, update: () => void) {
  // Icon downloads can finish after the owning map has already been removed.
  if (map._removed) return () => {};
  let pending = true;
  const cancel = () => {
    pending = false;
    map.off('render', apply);
    map.off('styledata', apply);
    map.off('remove', cancel);
  };
  const apply = () => {
    if (!pending || !map.isStyleLoaded()) return;
    // Detach before updating: adding sources/layers can emit styledata again.
    cancel();
    update();
  };
  map.on('render', apply);
  map.on('styledata', apply);
  map.on('remove', cancel);
  apply();
  return cancel;
}
